export default "__VITE_ASSET__ifbXHDUp__"